<template>
  <div class="corporate-payment">
    <el-dialog width="594px" :close-on-click-modal="false" :visible="visible" @close="$emit('close')">
      <div class="warning">
        <i class="iconfont icon-icon-xinxijingshi"></i>
        <span>完成付款后，请上传付款回执图片或截图</span>
      </div>
      <div class="content">
        <div class="ul">
          <div class="li">
            <div class="label">企业全称</div>
            <div class="value">{{ accountData.accountName | noText }}</div>
          </div>
          <div class="li">
            <div class="label">银行账户</div>
            <div class="value">
              {{ accountData.account | noText }}
            </div>
          </div>
          <div class="li">
            <div class="label">开户行</div>
            <div class="value">
              {{ accountData.accountBank | noText }}
            </div>
          </div>
          <div class="li">
            <div class="label">转账备注</div>
            <div class="value">
              {{ accountData.orderNo | noText }}
            </div>
          </div>
          <div class="li">
            <div class="label">转账金额</div>
            <div class="value">
              <span>{{ amount | formatMoney }}</span>
              <i>元</i>
            </div>
          </div>
        </div>
        <div class="file">
          <div class="label">付款回执</div>
          <Upload
            :acceptType="acceptType"
            :uploadHandling="false"
            :fileListArr="imgList"
            :totalNum="1"
            :paramsupload="paramsupload"
            :size="10"
            maxFiles="最多可上传1个文件"
            flieSize="单个文件最大不可超过10M"
            @changeFileList="changeFileList"
            :recordsFlag="true"
          ></Upload>
        </div>
      </div>
      <div class="btns">
        <div class="btn">
          <el-button type="primary" @click="submit" :loading="loading">完成支付</el-button>
        </div>
        <div class="btn">
          <el-button type="text" @click="setClipBoardText($event, copyValue)"
            >复制转账信息</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { corporatePrePublicPay, corporatPublicPay } from '@/utils/api/order'
import Upload from './Upload.vue'
import setClipBoardText from '@/utils/clipboard'
export default {
  props: {
    orderNo: {},
    amount: {
      default: 0,
    }
  },

  components: {
    Upload,
  },

  data() {
    return {
      visible: true,
      accountData: {},
      acceptType: '.jpg, .jpeg, .png,',
      imgList: [],
      paramsupload: {
        source: 92,
        sourceType: 92,
        isCreateThumbnail: false,
        project: 'haizol-order-web-online',
        modelType: 6,
        isCreateThumbnail: false,
        picSizeType: 1,
      },
      loading: false,
    }
  },

  computed: {
    // 复制的内容
    copyValue() {
      try {
        let str = ''
        const formatMoney = this.$options.filters.formatMoney
        const accountName = `企业全称：${this.accountData.accountName}`
        const account = `银行账户：${this.accountData.account}`
        const accountBank = `开户行：${this.accountData.accountBank}`
        const orderNo = `转账备注：${this.accountData.orderNo}`
        const totalAmount = `转账金额：${formatMoney(
          this.amount
        )}元`
        str = `${accountName}\n${account}\n${accountBank}\n${orderNo}\n${totalAmount}\n*财务对公打款后，请在订单页面上传付款回执单\n如需帮助请联系400-660-5995`
        return str
      } catch(err) {
        console.error("❌ ~ file: CorporatePayment.vue:121 ~ copyValue ~ err:", err)
        this.$message.error('系统异常，请稍后再试')
        return ''
      }
    },
  },

  methods: {
    setClipBoardText,

    async initData() {
      try {
        const res = await corporatePrePublicPay({
          orderNo: this.orderNo,
        })
        if (res.rspResult.bizCode === 200) {
          this.accountData = res.data
        }
      } catch(err) {
        console.error("❌ ~ file: CorporatePayment.vue:140 ~ initData ~ err:", err)
      }
    },

    // 当附件上传发生变化时
    changeFileList(arr, flag) {
      this.imgList = arr
    },

    async submit() {
      try {
        // if(!this.imgList.length) return this.$message.error('请上传付款回执')
        this.loading = true
        const res = await corporatPublicPay({
          orderNo: this.orderNo,
          receipts: this.imgList.map((ele) => ele.hashCode),
        })
        if (res.rspResult.bizCode === 200) {
          this.$router.push({
            name: 'const-center-public-success',
          })
        } else {
          this.loading = false
        }
      } catch(err) {
        console.error("❌ ~ file: CorporatePayment.vue:162 ~ submit ~ err:", err)
        this.loading = false
      }
      
    },
  },

  created() {
    this.initData()
  },
}
</script>

<style lang="scss" scoped>
.corporate-payment {
  .warning {
    position: absolute;
    top: 32px;
    left: 117px;
    width: 380px;
    height: 36px;
    background: #ff7f2a1a;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      font-size: 12px;
      color: #ff7f2a;
      margin-right: 6px;
    }
    span {
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #ff7f2a;
    }
  }
  ::v-deep .el-dialog__header {
    height: 68px;
    padding: 0;
  }
  ::v-deep .el-dialog__body {
    padding-top: 23px;
  }
  ::v-deep .el-dialog__headerbtn {
    top: 43px;
    i {
      font-size: 20px;
      font-weight: bold;
    }
  }
  .content {
    margin: 0 auto;
    width: 380px;
    .ul {
      .li {
        display: flex;
        align-items: center;
        margin-bottom: 24px;
        height: 14px;
        .label {
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #4f5d78;
          width: 56px;
          margin-right: 24px;
          height: 14px;
          line-height: 14px;
        }
        .value {
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #16181a;
          height: 14px;
          line-height: 14px;
        }
        &:nth-child(4) {
          &::after {
            content: '(打款时备注信息)';
            font-family: SourceHanSansCN-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #ef2a2a;
            margin-left: 6px;
          }
        }
        &:last-child {
          .value {
            span {
              color: #ef2a2aff;
              font-size: 20px;
              font-weight: bold;
              height: 14px;
              line-height: 14px;
            }
            i {
              color: #ef2a2aff;
              font-size: 14px;
              font-weight: 400;
            }
          }
        }
      }
    }
    .file {
      display: flex;
      margin-bottom: 40px;
      .label {
        margin-right: 24px;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #4f5d78;
      }
    }
  }

  .btns {
    // margin-top: 40px;
    .btn {
      text-align: center;
      &:first-child {
        button {
          width: 216px;
          height: 44px;
          background: #066eb7;
          border-radius: 4px;
          font-size: 16px;
          margin-bottom: 10px;
        }
      }
      &:last-child {
        ::v-deep button {
          span {
            color: #066eb7;
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
